
<div class="popup-manageResa popup-aside-float" :class="{ 'popup-manageResa-dark': currentMod === 'EDIT' }">
  <div class="popup-manageResa-header">
    <div class="nav-toggle" @click="closePopup">
      <div id="nav-icon3" class="open">
        <span></span><span></span><span></span><span></span>
      </div>
    </div>
    <div class="popup-manageResa-title" :class="getHeaderClass">
      <div class="popup-manageResa-title-content">{{ getHeaderTitle }}</div>
    </div>
  </div>
  <div ref="popup-manageResa" class="popup-manageResa-container">
    <transition name="fade">
      <div class="popup-manageResa-content" v-if="currentMod === 'READ'">
        <div class="popup-manageResa-resaTitle">
          {{ getSelectedResa.dateResa.labelDay }} {{ getSelectedResa.dateResa.day }}
          {{ getSelectedResa.dateResa.labelMonth }} à {{ getSelectedResa.hour }}
        </div>
        <div class="popup-manageResa-resaTitle"
          v-if="getSelectedResa.tids !== undefined && getSelectedResa.tids.length > 0">
          Table<span v-if="getSelectedResa.tids.length > 1">s</span>
          <span> {{ getLinkedTablesToString }}</span>
        </div>
        <div class="popup-manageResa-line">
          <div v-if="getSelectedResa.discount" class="popup-manageResa-discount">
            <p>
              -{{ getSelectedResa.discount }}%
            </p>
          </div>
          <div class="popup-manageResa-nbCouvert-count">
            {{ getSelectedResa.nbCouvert }}
          </div>
          <div class="popup-manageResa-nbCouvert"></div>
          <div class="popup-manageResa-tag" :class="'popup-manageResa-tag-' + getSelectedResa.source.toLowerCase()">
          </div>
          <div :class="[
            'popup-manageResa-cash',
            'popup-manageResa-cash-' + resaPayementColorState,
          ]" v-if="this.getSelectedResa.type !== '' && getSelectedResa.amount > 0">
            {{ getTypeCash(getSelectedResa.type) }} :
            <span v-if="getSelectedResa.total">{{ getSelectedResa.total }}</span><span v-else>{{
              Math.round((getSelectedResa.amount * getSelectedResa.nbCouvert) * 100) / 100 }}</span>€
          </div>
        </div>
        <div class="popup-manageResa-label">
          <client-tag v-for="tag in getClientByid(clientResa.cid).tags.slice().sort()" :key="tag" :idTag="tag"
            :deletable="false" :cid="clientResa.cid"></client-tag>
        </div>
        <div class="popup-manageResa-denom" @click="editClientInfos(clientResa.cid)">
          {{
            clientResa.civ === "Mme." ? clientResa.civ.replace(".", "") : clientResa.civ
          }}
          {{ clientResa.name }} {{ clientResa.prenom }}
          <img class="popup-manageResa-denom-img" src="../../assets/svg/asset-more.svg" alt="" />
          <span class="popup-manageResa-societe" v-if="clientResa.societe && clientResa.societe !== ''">
            <br />
            {{ clientResa.societe }}
          </span>
        </div>
        <div class="popup-manageResa-contact">
          <span v-if="formatPhone(clientResa.tel, clientResa.telPreFix)">
            <a :href="'tel:' + formatPhone(clientResa.tel, clientResa.telPreFix)">{{
              formatPhone(clientResa.tel, clientResa.telPreFix)
            }}</a>
            <br /><br />
          </span>
          <a v-if="clientResa.email !== '-' || clientResa.email !== '' || clientResa.email !== ' '"
            :href="'mailto:' + clientResa.email">{{
              clientResa.email
            }}</a>
        </div>
        <div class="popup-manageResa-comment"
          v-if="getSelectedResa.allergen && getSelectedResa.allergenMessage !== ''">
          <div class="popup-manageResa-tag" :class="'popup-manageResa-tag-allergen'"></div>
          {{ getSelectedResa.allergenMessage }}
        </div>
        <div class="popup-manageResa-preFixServ"
          v-if="getSelectedResa.preFixServ && getSelectedResa.preFixServ !== ''">
          Interne : {{ getSelectedResa.preFixServ }}
        </div>
        <div class="popup-manageResa-comment" v-if="clientResa.comment && clientResa.comment !== ''">
          Note client : {{ clientResa.comment }}
        </div>
        <div class="popup-manageResa-comment"
          v-if="getSelectedResa.commentResa && getSelectedResa.commentResa !== ''">
          Note réservation : {{ getSelectedResa.commentResa }}
        </div>
        <div class="popup-manageResa-state" v-if="
          (getStateResa === 'CONFIRMED' ||
            getStateResa === 'NO_SHOW' ||
            getStateResa === 'NEED_TABLE' ||
            getStateResa === 'SHOW') &&
          clientResa.cid !== 'passage'
        ">
          <el-radio-group v-if="inCurrentService(true)" v-model="radioState" @change="changeStateConfirmedResa">
            <el-radio-button class="red" label="No show" value="NO_SHOW"></el-radio-button>
            <el-radio-button label="Neutre" value="CONFIRMED"></el-radio-button>
            <el-radio-button class="green" label="Show" value="SHOW"></el-radio-button>
          </el-radio-group>
        </div>
        <div
          v-if="(getStateResa === 'SHOW' || getStateResa === 'DONE') && getAllInfos.restoReviewsLinks && getAllInfos.restoReviewsLinks.length > 0"
          class="popup-manageResa-btns popup-manageResa-reviews black-inputs">
          <el-button v-if="!askReview && !getAllInfos.restoReviews" class="green" type="primary"
            @click="askForReviews()">Demande d'avis</el-button>
          <div v-else-if="askReview" class="popup-manageResa-reviews-txt">
            Demande d'avis envoyé
          </div>
        </div>
        <div class="popup-manageResa-btns black-inputs">
          <el-button v-if="getStateResa === 'TO_CONFIRM'" type="primary" @click="confirmResa">Valider la
            réservation</el-button>
          <el-button v-if="
            getStateResa !== 'CANCELLED' &&
            getStateResa !== 'NO_SHOW' &&
            getStateResa !== 'DONE' &&
            clientResa.cid !== 'passage'
          " class="dark" type="primary" @click="editResa">Modifier les informations</el-button>
          <el-button v-if="
            getStateResa !== 'CANCELLED' &&
            getStateResa !== 'NO_SHOW' &&
            getStateResa !== 'SHOW' &&
            getStateResa !== 'DONE'
          " class="dark" type="primary" @click="reSendConfirm">Renvoyer les informations</el-button>
          <el-button v-if="
            getStateResa !== 'CANCELLED' &&
            getStateResa !== 'NO_SHOW' &&
            getStateResa !== 'SHOW' &&
            getStateResa !== 'DONE'
          " class="dark" type="primary" @click="cancelResa">Annuler la réservation</el-button>
          <el-button v-if="getStateResa === 'SHOW'" class="dark" type="primary" @click="setTableDONE()">Libérer les
            tables</el-button>
        </div>
        <div class="popup-manageResa-booking">
          Enregistrée le :<br> {{ getDateBooking }} depuis <span class="capitalize">{{ getSelectedResa.source
          }}</span><br>
          <span v-if="getStateResa !== 'CANCELLED' && getDateModify && getModifyBy">
            Mise à jour le :<br> {{ getDateModify }} par {{ getModifyBy }}
          </span>
          <span v-else-if="getDateModify && getModifyBy">
            Annulée le :<br> {{ getDateModify }} par {{ getModifyBy }}
          </span>
        </div>
      </div>
      <div class="popup-manageResa-content" v-if="currentMod === 'EDIT'">
        <el-row class="black-inputs">
          <el-col :span="20" :offset="2">
            <el-form ref="editForm" :rules="rulesFormPart1" :model="editForm" label-width="0px">
              <el-form-item class="civ">
                <el-radio-group v-model="editForm.civ">
                  <el-radio-button label="M."></el-radio-button>
                  <el-radio-button label="Mme"></el-radio-button>
                </el-radio-group>
              </el-form-item>
              <el-form-item prop="clientPreFix" class="cPrefix">
                <el-input v-model="editForm.preFix" placeholder="Préfixe"></el-input>
              </el-form-item>
              <el-form-item prop="name">
                <el-input v-model="editForm.name" placeholder="Nom*"></el-input>
              </el-form-item>
              <el-form-item prop="prenom">
                <el-input v-model="editForm.prenom" placeholder="Prénom*"></el-input>
              </el-form-item>
              <el-form-item prop="email">
                <el-input v-model="editForm.email" placeholder="e-mail*"></el-input>
              </el-form-item>
              <el-form-item prop="telPreFix" class="tel-prefix">
                <el-input v-model="editForm.telPreFix" placeholder="+33"></el-input>
              </el-form-item>
              <el-form-item prop="tel" class="tel">
                <el-input v-model="editForm.tel" placeholder="Téléphone*"></el-input>
              </el-form-item>
              <el-form-item>
                <el-input v-model="editForm.societe" placeholder="Société"></el-input>
              </el-form-item>
              <el-form-item>
                <el-input-number @focus="focusNumber" class="text-centered" style="width: 100%" size="medium" :min="1"
                  v-model="editForm.nbCouvert"></el-input-number>
              </el-form-item>
              <el-form-item>
                <calendar-nav-picker />
              </el-form-item>
              <el-form-item>
                <div class="popup-takeResa-dayClosed" v-if="getServicesHours === null">
                  Fermé
                </div>
                <el-select v-if="getServicesHours !== null" class="text-centered" v-model="editForm.hour"
                  @change="serviceChange" value-key="id" placeholder="Choisissez une heure">
                  <el-option-group v-for="ms in getServicesHoursData" :key="ms.label" :label="ms.label"
                    v-if="ms.tab.length > 0">
                    <el-option v-for="h in ms.tab" :key="h.id" :label="h.hour" :value="h">
                    </el-option>
                  </el-option-group>
                </el-select>
              </el-form-item>
              <el-form-item prop="allergen">
                <div>
                  <el-radio-group v-model="editForm.allergen" @change="$refs['editForm'].clearValidate()">
                    <el-radio style="white-space: normal; padding:5px 10px" :label="false">Aucune intolérance ou
                      allergie pour l’ensemble des convives</el-radio>
                    <el-radio style="white-space: normal; padding:5px 10px" :label="true">Intolérance / Allergie
                    </el-radio>
                  </el-radio-group>
                </div>
              </el-form-item>
              <el-form-item v-if="editForm.allergen" prop="allergenMessage">
                <el-input v-model="editForm.allergenMessage" :autosize="{ minRows: 3 }" type="textarea"
                  placeholder="Merci de renseigner les intolérances / allergies"></el-input>
              </el-form-item>
              <el-form-item>
                <el-input v-model="editForm.commentResa" :autosize="{ minRows: 3 }" type="textarea"
                  placeholder="Commentaire concernant la réservation"></el-input>
              </el-form-item>
              <el-form-item>
                <el-input v-model="editForm.preFixServ" placeholder="Interne"></el-input>
              </el-form-item>
              <el-form-item>
                <el-button type="primary" @click="validModifResa()">Valider</el-button>
              </el-form-item>
              <el-form-item>
                <el-button class="dark" type="primary" @click="closeEditResa()">Annuler</el-button>
              </el-form-item>
            </el-form>
          </el-col>
        </el-row>
      </div>
    </transition>
  </div>
</div>
